import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {ensureAuthenticated} from "../auth/authenticate";
import TRSRestrict from "../TRSRestrict";
import config from '../config/config';
import log from '../utils/logger';
import {getStage} from "./environment";
import {createRoot} from "react-dom/client";


const APIClient = {
    
    invoke: function (method, path, parameterJSON, dataJSON, callback) {
        ensureAuthenticated().then(auth => {
            let url = config.businessLogicAPI[getStage()] + config['apiStage'] + path
                + "?username=" + localStorage.getItem("userID");
            log.logInfo("dataJSON: " + JSON.stringify(dataJSON) + " parameterJSON: " + JSON.stringify(parameterJSON));
            for (let param in parameterJSON)
                url = url + "&" + param + "=" + parameterJSON[param];

            let opts = {
                method: method,
                headers: {'Authorization': auth.getSignInUserSession().getIdToken().getJwtToken()},
            };
            if (method === "POST" || method === "PUT") {
                if (path === 'tradeapproval' || path === 'attachDocuments'||
                    path === '/file/url' || path === 'attachDocuments/singleDelete' ||
                    path === 'exportSettlements' || path === 'exportFxSettlements') {
                    opts["body"] = JSON.stringify(dataJSON);
                } else {
                    opts["body"] = JSON.stringify({data: dataJSON});
                }
            }

            log.logInfo("url: " + url);
            fetch(url, opts).then(function (response) {
                return response.json();
            }).then(function (data) {
                log.logInfo("data fetched = " + data.toString());
                callback(null, data);
            }).catch((e) => {
                log.logError(e);
                return callback(e);
            })
        }).catch(() => {
            // https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
            const container = document.getElementById('app');
            const root = createRoot(container);
            root.render(<BrowserRouter>
                <TRSRestrict/>
            </BrowserRouter>)
        })
    }
};

export default APIClient;